import { GOOGLE_SHEET_URL } from 'config'

export const sendDataToGoogleSheets = (data) =>
  fetch(`${GOOGLE_SHEET_URL}`, {
    method: 'POST',
    body: data
  })
